export default __webpack_public_path__ + "static/media/krzyzowka_2.a2f5b9e3.jpg";